import { useTranslation } from "@/i18n";

const Row = ({ items }) => (
  <div className="flex shrink-0 items-center">
    {items.map((item) => (
      <span key={item} className="flex items-center">
        <span className="font-serif italic font-light text-3xl sm:text-5xl text-[#FAF8F5]/80 whitespace-nowrap px-8">
          {item}
        </span>
        <span className="text-gold text-xl">✦</span>
      </span>
    ))}
  </div>
);

export default function Marquee() {
  const { t } = useTranslation();
  const items = t("marquee.items");

  return (
    <div
      className="relative py-14 border-y border-gold/10 bg-ink overflow-hidden"
      data-testid="editorial-marquee"
    >
      <div className="flex w-max animate-marquee hover:[animation-play-state:paused]">
        <Row items={items} />
        <Row items={items} />
      </div>
    </div>
  );
}
